import { useQuery } from "@tanstack/react-query";
import EnvironmentService from "services/environment.service";
import { unwrapResponse } from "shared/networking/unwrapResponse";
import { siteInfoKeys } from "shared/queryKeys";

export function useSiteInformation() {
  return useQuery({
    queryKey: siteInfoKeys.all,
    queryFn: async () => {
      const response = await EnvironmentService.getSoftwareVersion();
      return unwrapResponse(response, "Software Informationen");
    },
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
